import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const NEDEN_RENK: Record<string, string> = { 'Arıza': '#ef4444', 'Bakım': '#3b82f6', 'Malzeme': '#f59e0b', 'Kalıp': '#8b5cf6', 'Operatör': '#06b6d4', 'Diğer': '#94a3b8' };
const NEDEN_RGB: Record<string, string> = { 'Arıza': '239,68,68', 'Bakım': '59,130,246', 'Malzeme': '245,158,11', 'Kalıp': '139,92,246', 'Operatör': '6,182,212', 'Diğer': '148,163,184' };

@Component({
  selector: 'durus-kaydi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--durus" [style.--accent]="nedenRenk()" [style.--accent-rgb]="nedenRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">DURUŞ KAYDI</div>
        <div class="dk-ust">
          <div class="dk-neden-badge">{{ p()?.neden || 'Arıza' }}</div>
          <div class="dk-sure">{{ p()?.sure || 0 }} <span class="dk-sure-label">DK</span></div>
        </div>
        @if (p()?.notlar) { <div class="dk-notlar">{{ p().notlar }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 50 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #9333ea; --accent-rgb: 147,51,234; }
    .dk-ust { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .dk-neden-badge { font-size: 10px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; padding: 3px 10px; border-radius: 2px; color: #fff; background: var(--accent); }
    .dk-sure { font-size: 22px; font-weight: 900; color: #c084fc; font-variant-numeric: tabular-nums; text-shadow: 0 0 12px rgba(192,132,252,.3); }
    .dk-sure-label { font-size: 10px; font-weight: 500; color: var(--py-metin-ikincil, #64748b); margin-left: 2px; }
    .dk-notlar { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  `],
})
export class DurusKaydiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  nedenRenk = computed(() => NEDEN_RENK[this.p()?.neden] || '#9333ea');
  nedenRgb = computed(() => NEDEN_RGB[this.p()?.neden] || '147,51,234');
}
